export default __webpack_public_path__ + "static/media/mailchimpIcon.c7b33ebc.svg";